import { render, staticRenderFns } from "./LanguageSettingPage.vue?vue&type=template&id=435c12de&scoped=true&"
import script from "./LanguageSettingPage.vue?vue&type=script&lang=js&"
export * from "./LanguageSettingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435c12de",
  null
  
)

export default component.exports